import { render } from "./WebchatTab.vue?vue&type=template&id=01143bdd&scoped=true&lang=pug"
import script from "./WebchatTab.js?vue&type=script&lang=js&external"
export * from "./WebchatTab.js?vue&type=script&lang=js&external"

import "./WebchatTab.vue?vue&type=style&index=0&id=01143bdd&lang=scss&scoped=true"
import "./WebchatTab.vue?vue&type=style&index=1&id=01143bdd&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01143bdd"]])

export default __exports__